import { addHours, fromUnixTime } from 'date-fns';

import { Event } from '@/types/Event';

import { getLiveBiddingUrl } from './urls';

export type CalendarEventArgs = {
    catalogId: number;
    description: string;
    saleStartTs: number;
    sellerName: string;
    title: string;
};

export const createCalendarEvent = ({
    catalogId,
    description,
    saleStartTs,
    sellerName,
    title,
}: CalendarEventArgs): Event => {
    const catalogLiveUrl = getLiveBiddingUrl(catalogId);

    const startTime = fromUnixTime(saleStartTs).getTime();

    const endTime = addHours(fromUnixTime(saleStartTs), 2).getTime();

    return {
        description: description,
        endTime,
        location:
            `https://www.liveauctioneers.com${catalogLiveUrl}` +
            '?utm_source=AddToCalendar&utm_medium=web&utm_campaign=LA_AddToCalendar',
        startTime,
        title: `${sellerName}: ${title}`,
    };
};
